import React, { useContext } from 'react'
import _ from 'lodash'

type RouteContextType = {
    assetURL?: string
    id?: string
    tab?: string
    entityId?: string
    query?: Record<string, any>
}
export const RouteContext = React.createContext<RouteContextType>({
    assetURL: null,
    id: null,
    tab: null,
    entityId: null,
    query: null
})

export function useRouteContext(): RouteContextType & {
    selectTab: (assetType: string, tab: string) => void
    selectEntity: (assetType: string, entityId: string) => void
    tabIsSelected: (assetType: string, _tab: string) => boolean
    getSelectedTab: () => string
} {
    const { assetURL, id, tab, entityId, query } = useContext(RouteContext)

    const selectTab = (assetType: string, tab: string): void => {
        if (id) window.location.hash = `/${assetType}/${id}/${tab.toLowerCase()}`
    }
    const tabIsSelected = (assetType: string, _tab: string): boolean => {
        return tab ? _tab.toLowerCase() === tab.toLowerCase() : false
    }

    const getSelectedTab = (): string => {
        return tab?.toUpperCase()
    }

    const selectEntity = (assetType: string, entityId: string): void => {
        if (id && tab) window.location.hash = `/${assetType}/${id}/${tab}/${entityId}`
    }

    return {
        assetURL,
        id,
        tab,
        entityId,
        query,
        selectTab,
        selectEntity,
        tabIsSelected,
        getSelectedTab
    }
}

type RouterProps = {
    urlParams: Array<any>
    extra: Record<string, any> & { assetURL: string }
}
// eslint-disable-next-line react/display-name
export const withRouteContext = (Component: React.ComponentType<RouterProps>) => (
    props: RouterProps
): React.ReactElement => {
    const [id, tab, entityId] = _.filter(props.urlParams, _.isString)
    const urlParams = _.clone(props.urlParams)
    const [query] = _.remove(urlParams, _.isObject)
    const assetURL = props.extra.assetURL

    return (
        <RouteContext.Provider value={{ assetURL, id, tab, entityId, query }}>
            <Component {...props} />
        </RouteContext.Provider>
    )
}
